import React from 'react';
import {FormControl, Box} from '@mui/material';
import { OutlinedInput } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { HighlightOff } from '@mui/icons-material';
import T from '../lib/translator';
import LinearProgress from '@mui/material/LinearProgress';
import { useDebounce } from 'use-debounce';
import { request } from '../lib/api';
import { getAbsolutePosition } from './fragments';

const BookSearch = ({book, search, setSearch, playlist}) => {
    const [value, setValue] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [ searchRequest ] = useDebounce(value, 750);
    const controllerRef = React.useRef(null);
    const [actualRequest, setActualRequest] = React.useState(0);

    React.useEffect(() => {
        if (!searchRequest.trim()) {
            setSearch([]);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
/*
        if (controllerRef.current) {
            //controllerRef.current.abort();
        }

        const controller = new AbortController();
        controllerRef.current = controller;
*/
        //export const textSearch = (books_id: number, query: string) => request('books/text/search', {books_id, query});
        var ar = actualRequest + 1;
        setActualRequest(ar);
        request('books/text/search', {books_id: book.id, query: searchRequest}, null, null, null/*controller.signal*/, ar).then(_ => {
            console.log(_);
/*
            if (_.request_id != actualRequest) {
                console.log("Drop non actual request " + _.request_id);
                return;
            } else {
                console.log("Process request " + _.request_id);
            }
*/
            setSearch(_.data.map((_, i) => {return {track: _.file - 1, position: Math.round(_.start * 1000), timer: getAbsolutePosition(playlist, _.file - 1, _.start * 1000), label: _.preview};}));
            //setSearch(_.data.map((_, i) => {return {track: i, position: 0, label: _.preview};}));
        }).catch().finally(_ => setIsLoading(false));

    }, [searchRequest]);

    React.useEffect(() => {
        if (value) {
            setIsLoading(true);
        }
        
        if (controllerRef.current) {
            //console.log("Abort request");
            //controllerRef.current?.abort();
        }

        setSearch([]);
    }, [value]);
  
    React.useEffect(() => {
        return () => {
            //controllerRef.current?.abort();
        };
    }, []);

    return <FormControl sx={{m: 0, 
            marginTop: 0,
            '& .MuiOutlinedInput-root': {
                marginTop: 0,
                marginBottom: 0,
            }                
        }}><OutlinedInput
            aria-label={T('Текст для поиска')}
            id="input-with-icon-adornment"
            variant="outlined"
            sx={{m: 0, pl: 1, pr: 1, marginTop: 0}}
            inputProps={{
                style: {
                    padding: '8px',
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            }}
            value={value}
            onChange = {(event) => {setValue(event.target.value);}}
            startAdornment={
                <InputAdornment position="start"><SearchIcon /></InputAdornment>
            }
            endAdornment={value &&
                <InputAdornment position="end">
                    <HighlightOff sx={{cursor: 'pointer'}} onClick={_ => {setValue(''); }}/>
                </InputAdornment>            
            }
        />    
    {isLoading && <LinearProgress
        tabIndex={0}
        aria-label={T('Выполняется поиск')}
        sx={{
            backgroundColor: "#00aec7",
            '& .MuiLinearProgress-bar': {
                backgroundColor: '#ffb27d'
            }
        }}
    />}
    {!isLoading && searchRequest && !search.length && <label tabIndex={0} style={{paddingLeft: 6}}>{T('Ничего не найдено') + ' :('}</label>}
    </FormControl>
}

export default BookSearch;